import { render, staticRenderFns } from "./CommunicationTrigger.vue?vue&type=template&id=56e77044&"
import script from "./CommunicationTrigger.vue?vue&type=script&lang=js&"
export * from "./CommunicationTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports